import { render, staticRenderFns } from "./dtl.vue?vue&type=template&id=6cd0e60d&scoped=true"
import script from "./dtl.vue?vue&type=script&lang=js"
export * from "./dtl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd0e60d",
  null
  
)

export default component.exports